export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-15.152d8e0a.png";